/**
 * 厅战入口
 */

import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import cls from 'classnames';
import { useBoolean } from 'react-hanger';

import { clientMedia, media, theme } from '@/lib';
import gamesFightUtils from '../utils';
import gamesFightStore from '../store';
import PkBoard from './pk-board';
import PkSvga from './pk-svga';

const GamesFightEntry = observer(() => {
  const foldCtrl = useBoolean(true);
  const { isFighting } = gamesFightStore.useStore();

  useEffect(() => {
    gamesFightUtils.fetchGamesFightInfo();
  }, []);

  useEffect(() => {
    foldCtrl.setFalse();
  }, [isFighting]);

  return (
    <>
      {isFighting && <PkSvga />}
      {isFighting && (
        <Wrap
          className={cls(
            'games-fight-entry',
            foldCtrl.value ? 'fold' : 'unfold',
          )}
        >
          <div className="fight-icon" onClick={foldCtrl.toggle}>
            <i className="fight-fold-icon" />
          </div>
          <PkBoard />
        </Wrap>
      )}
    </>
  );
});
const Wrap = styled.div`
  position: absolute;
  z-index: ${theme.videoZIndex.fightPk};
  right: -1px;
  top: -3px;
  width: 36px;
  height: 86px;
  display: flex;
  flex-wrap: nowrap;
  overflow: hidden;
  border-radius: 8px;
  background: url(${require('../images/bg-info-extend-2.png')}) no-repeat center /
    100% 100%;
  transition: width 200ms ease-in-out;

  ._dark & {
    top: auto;
    right: 0;
    bottom: 0;
    background: url(${require('../images/client/bg-info-extend-2.png')})
      no-repeat center / 100% 100%;
    .pk-info-bar {
      width: 95%;
    }
  }

  ._dark.page-normal & {
    ${clientMedia.media1600} {
      background: url(${require('../images/client/bg-info-extend-3.png')})
        no-repeat center / 100% 100%;
    }
    ${clientMedia.media1280} {
      background: url(${require('../images/client/bg-info-extend-4.png')})
        no-repeat center / 100% 100%;
      .pk-info-bar {
        width: 92%;
      }
    }
    ${clientMedia.media1080} {
      background: url(${require('../images/client/bg-info-extend-5.png')})
        no-repeat center / 100% 100%;
      .pk-info-nick {
        max-width: 90px;
      }
      .pk-info-bar {
        width: 87%;
      }
    }
  }

  &.unfold {
    width: 100%;

    .fight-icon {
      background-image: none;
      i {
        background-image: url(${require('../images/icon-right.png')});
      }
    }
    .pk-board {
      width: 923px;
      padding: 8px 10px 0;
    }
  }
  .pk-board {
    width: 563px;
  }

  ${media.mediaDownMd} {
    background: url(${require('../images/bg-info-extend-1.png')}) no-repeat
      center / 480px 86px;
    .pk-board {
      width: 444px;
    }
  }

  .fight-icon {
    box-sizing: border-box;
    width: 36px;
    flex: 0 0 36px;
    height: 100%;
    padding-top: 16px;
    text-align: center;
    cursor: pointer;
    background: url(${require('../images/bg-info.png')}) no-repeat right /
      contain;
    &::before {
      display: block;
      content: '';
      margin: 0 auto 0;
      width: 18px;
      height: 36px;
      background: url(${require('../images/text-room-fight.png')}) no-repeat
        center / contain;
    }
    i {
      display: block;
      margin: 6px auto 0;
      content: '';
      width: 16px;
      height: 16px;
      background: url(${require('../images/icon-left.png')}) no-repeat center /
        contain;
    }
  }
`;

export default gamesFightStore.withStore(GamesFightEntry);
